<template>
  <div>
    <b-col
      lg="12"
      md="12"
      sm="12"
      class="mb-1"
    >
      <b-link
        style="font-size: 26px; color: #fff;"
        @click="checkTotal()"
      >
        <feather-icon
          style="margin-bottom: 5px;"
          size="34"
          icon="ArrowLeftIcon"
        /><span style="color: #00FF80;"> กล้องวงจรปิด: </span>{{ waydetail }}
      </b-link>
    </b-col>

    <b-row>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 610px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">

          <l-map
            ref="mymap"
            :zoom="zoom"
            :center="center"
            style="width: 100%; height: 560px; z-index: 0"
            :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
            @update:zoom="zoomUpdated"
          >
            <l-tile-layer :url="url" />
            <l-marker
              v-for="(marker, index) in markers"
              :key="'marker'+index"
              :ref="'marker'+index"
              :lat-lng="[marker.Latitude, marker.Longitude]"
              :options="{ autoClose: false, closeOnClick: false }"
              @click="stream(marker.RTSP_HLS, marker.Camera_Desc)"
            >
              <l-icon
                :icon-size="[28, 40]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/MakerCCTV.svg')"
              />
              <l-popup
                ref="popup"
              >
                <div>
                  <span style="color:white; padding: 1px; text-align: left; font-size:14px;">
                    ตำแหน่ง:{{ camdesc }}
                  </span>
                  <video
                    id="video"
                    style="width:250px; height:auto; flex-direction: row;"
                    muted
                    autoplay
                    playsinline
                  />
                </div>
              </l-popup>
            </l-marker>
          </l-map>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Hls from 'hls.js'
import {
  BRow, BCol, BLink, BCard,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BLink,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    BCard,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      center: [0, 0],
      waydetail: '',
      markers: [],
      camdesc: '',
      deptid: '',
      lat: '',
      lng: '',
      type_name: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  created() {
    this.getWayCCTV()
  },
  mounted() {
    this.getMarkerCCTV()
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())
  },
  methods: {
    checkTotal() {
      axios
        .post('/checkCCTVTotal', { DeptID: this.deptid })
        .then(response => {
          if (response.data[0].count_deptid > 1) {
            this.$router.push({ path: '/cctv-sub', query: { DeptID: this.deptid } })
          } else {
            this.$router.push({ path: '/cctv-total' })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getWayCCTV() {
      axios
        .post('/getWayCCTVDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.zoom = response.data[0].mapzoom
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMarkerCCTV() {
      axios
        .post('/getTableCCTVDetail', { wid: this.$route.query.wid, username: this.userData.username })
        .then(response => {
          this.markers = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    zoomUpdated(value) {
      setTimeout(() => axios
        .post('/updateMapZoom', {
          mapzoom: value, wid: this.$route.query.wid, type_name: this.type_name,
        })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
        })
        .catch(error => {
          console.log(error)
        }), 1000)
    },
    stream(value, camdesc) {
      setTimeout(() => {
        this.camdesc = camdesc
        const hls = new Hls({
          lowLatencyMode: true,
          autoreconnect: true,
        })
        const stream = value
        const video = document.querySelector('#video')
        hls.loadSource(stream)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
        hls.on(Hls.Events.ERROR, () => {
          video.play()
        })
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.95);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}
</style>
